import React, { useState } from 'react'
import I18n from 'lib/i18n'

export default function SlideThree ({ slideIndex }) {
  const [expand, setExpand] = useState(false)
  const style = slideIndex === 4 ? { display: 'flex', justifyContent: 'space-between' } : { display: 'none' }

  return (
    <div className='slide.slide-4' style={style}>
      <div className='left-par not-responsive'>
        <div className='not-responsive-inline-block' style={{ maxWidth: 410, margin: '0 auto' }}>
          <img
            className='lazyload'
            data-src='/assets/pages/how1/owl-calendar.png'
            data-retina='/assets/pages/how1/owl-calendar@2x.png'
            style={{ maxWidth: '100%', width: 'auto !important', height: 'auto !important' }}
            alt=''
          />
        </div>
      </div>
      <div className='right-part'>
        <h3 dangerouslySetInnerHTML={{ __html: I18n.t('pages.how1.teachers_1_title') }} />
        <div className='only-responsive-inline-block' style={{ maxWidth: 410, margin: '0 auto', marginBottom: 10 }}>
          <img
            className='lazyload'
            data-src='/assets/pages/how1/owl-calendar.png'
            data-retina='/assets/pages/how1/owl-calendar@2x.png'
            style={{ maxWidth: '100%', width: 'auto !important', height: 'auto !important' }}
            alt=''
          />
        </div>
        <div dangerouslySetInnerHTML={{ __html: I18n.t('pages.how1.teachers_1') }} />
      </div>
    </div>
  )
}
